var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M9.99984 1.66663C14.6082 1.66663 18.3332 5.39163 18.3332 9.99996C18.3332 14.6083 14.6082 18.3333 9.99984 18.3333C5.39151 18.3333 1.6665 14.6083 1.6665 9.99996C1.6665 5.39163 5.39151 1.66663 9.99984 1.66663ZM12.9915 5.83329L9.99984 8.82496L7.00817 5.83329L5.83317 7.00829L8.82484 9.99996L5.83317 12.9916L7.00817 14.1666L9.99984 11.175L12.9915 14.1666L14.1665 12.9916L11.1748 9.99996L14.1665 7.00829L12.9915 5.83329Z",
  fill: "#627FE9"
})));
export default __webpack_public_path__ + "teg/media/closeIconT1.13f3d36e.svg";
export { SvgComponent as ReactComponent };